import React from "react";
import { Link, useNavigate } from "react-router-dom";
import startlogo from "../../assests/images/logostart.png";
const PageNotFound = () => {
  const router = useNavigate();
  const homePage = () => {
    router("/dashboard");
  };
  return (
    <>
      <div
        className="error-page-wrapper "
        style={{
          backgroundImage: `url(/images/404.jpg)`,
        }}
        data-aos="fade"
      >
        <div className="content">
          <div className="logo mb-5">
            <Link href="/">
              <img width={"100%"} height={"100%"} src={startlogo} alt="brand" />
            </Link>
          </div>
          {/* End logo */}

          <h1>404!</h1>
          <p>The page you are looking for could not be found.</p>

          <div className="theme-btn btn-style-one cursor" onClick={homePage}>
            BACK TO HOME
          </div>
        </div>
        {/* End .content */}
      </div>
    </>
  );
};

export default PageNotFound;
